import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './LivingSpacePopoverContent.module.css'

const LivingSpacePopoverContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex gap-l padding-m ${styles.container}`}>
      <span className={'font-body-medium-regular'}>{t('wizard.screen.basicInfo.livingSpace.popover.warningText')}</span>
      <div>
        <strong>{t('wizard.screen.basicInfo.livingSpace.popover.sectionHeader')}</strong>
        <ul className={'font-body-medium-regular list-bullet'}>
          <li>
            <strong>{t('wizard.screen.basicInfo.livingSpace.popover.percentage100')}</strong>{' '}
            {t('wizard.screen.basicInfo.livingSpace.popover.percentage100Description')}
          </li>
          <li>
            <strong>{t('wizard.screen.basicInfo.livingSpace.popover.percentage50')}</strong>{' '}
            {t('wizard.screen.basicInfo.livingSpace.popover.percentage50Description')}
          </li>
          <li>
            <strong>{t('wizard.screen.basicInfo.livingSpace.popover.percentage25')}</strong>{' '}
            {t('wizard.screen.basicInfo.livingSpace.popover.percentage25Description')}
          </li>
        </ul>
      </div>
    </div>
  )
}

export default LivingSpacePopoverContent
